import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Modal from 'simple-react-modal';

import { capitalize } from '../../utils/helpers';
import PaysafeForm from '../../components/paymentComponents/PaysafeForm';
import callApi from '../../utils/callApi';
import { LIST_EPAY_PACKAGES, CC_UPDATE_URL, CREDENTIALS_URL } from '../../constants/apiUrls/apiUrls';
import Alert from '../../components/generalComponents/Alert';
// import playboy from '../../assets/subscriptionsPage/playboy_nakednews-9781beb5296c25ddae404a99e8f8c3a4.png'
// import nakedNews from '../../assets/subscriptionsPage/nakednews-ba7baf4a2075dbd782664fff88faf31c.png'
import { /* PROCESSOR_OPT_STATUS,*/ PROCESSOR_ERROR_CODES } from '../../constants/processors';

import { AccountTabs } from './AccountTabs';


class SubscriptionsPage extends React.Component {
  static propTypes = { user: PropTypes.object };

  constructor(props) {
    super(props);
    this.state = {
      showPaysafeModal: false,
      programs: [],
      holderName: '',
      country: '',
      zip: '',
      email: '',
      errors: [],
      processingPayment: false,
      disablePurchaseButton: false,
      showAlert: false,
      alertMessage: '',
      alertType: '',
    };
  }

  componentDidMount() {
    this.fetchPackages();
    this.getCredentials();
  }

  getTitle = (target) => {
    switch (target) {
      case 'MRSKIN':
        return 'Mr. Skin';
      case 'PLAYBOY_PLUS':
        return 'Playboy Plus';
      default:
        return 'Naked News';
    }
  };

  getCredentials = () => {
    const { username, account } = this.props.user.user;
    if (account && account.subscription && account.subscription.processorId) {
      const { processorId } = account.subscription;
      const url = CREDENTIALS_URL.replace(
        '{username}',
        encodeURIComponent(username)
      ).replace('{processorId}', encodeURIComponent(processorId));
      callApi(url, 'GET', {}, {}, {}, false).
        then((res) => {
          this.setState({ singleUseApiKey: res.data.singleUseApiKey });
        }).
        catch((e) => console.error(e));
    }
  };

  resetPaysafeForm = () => {
    this.setState((state) => {
      return {
        ...state,
        holderName: '',
        country: '',
        zip: '',
        email: '',
        errors: [],
      };
    });
  };

  getPaysafeInitErrorMessage = (error) => {
    switch (error.code) {
      case '9044':
        return 'Invalid field: country code';
      case '9045':
        return 'Invalid field: ZIP code';
      case '9003':
        return error.displayMessage;
      default:
        break;
    }
  };

  getBillingAddress = () => {
    const { country, zip } = this.state;

    return {
      country,
      zip,
    };

  };

  getErrorMessage = (errorCode) => PROCESSOR_ERROR_CODES[errorCode] ? PROCESSOR_ERROR_CODES[errorCode] : 'Unknown.';

  handlePaysafeSubmit = (instance) => {
    const { user } = this.props;
    const { activeProgram, holderName } = this.state;
    const billingAddress = this.getBillingAddress();

    const paysafeData = { vault: { holderName, billingAddress } };
    instance.tokenize(
      paysafeData, (instance, error, result) => {
        if (error) {
          this.setPurchaseButtonDisabled(false);
          const errorMessage = this.getPaysafeInitErrorMessage(error);
          this.setState((state) => {
            return {
              errors: [
                ...state.errors,
                errorMessage,
              ],
            };
          });
        } else {
          const data = {
            userName: this.props.user.user.username,
            holderName,
            token: this.props.user.user.token,
            paymentToken: result.token,
          };
          callApi(CC_UPDATE_URL, 'PUT', false, JSON.stringify(data), {}, false).
            then((res) => {
              if (res.status === 200) {
                this.setState({
                  showPaysafeModal: false,
                  alertType: 'success',
                  alertMessage: 'Credit Card Details Updated',
                });
                this.showAlert();
              }
            }).
            catch((error) => {
              const { errorCode, transactionId, requestId } = error.response.data;
              this.setState({
                showPaysafeModal: false,
                alertType: 'error',
                alertMessage: `Update Failed. Reason: ${this.getErrorMessage(errorCode)} Transaction ID: ${transactionId || requestId}`,
              });
              this.showAlert();
              console.error(error);
            });
        }
      });
  };

  openPaysafeModal = () => this.setState({ showPaysafeModal: true });
  closePaysafeModal = () => this.setState({ showPaysafeModal: false });

  showAlert = () => {
    this.setState({ showAlert: true });
  };

  hideAlert = () => {
    this.setState({ showAlert: false });
  };

  getRecurringMessage = (subscription) => {
    const { amount, currency, rebillAmount, type, unit, period } = subscription;
    const allDataAvailable = (amount && currency && rebillAmount && type && unit);
    if (!allDataAvailable) {
      return '';
    }

    const rebillUnit = () => {
      if (unit === 'DAYS') {
        const months = Math.round(period / 30);
        if (months == 12 || unit == 365) {
          return 'year';
        }

        return months > 1 ? `${months} months` : 'month';
      }
      if (period == 12) {
        return 'year';
      }

      return period > 1 ? `${period} months` : 'month';

    };

    return `Recurring at ${rebillAmount} ${currency}/${rebillUnit()}.`;
  };

  fetchPackages = () => {
    callApi(LIST_EPAY_PACKAGES, 'get', {}, {}, {}, false).
      then((res) => {
        this.setState({ programs: res.data.products });
      }).
      catch((e) => console.error(e));
  };

  displaySubscriptionStatus = (subscription) => {
    const trullyExpired = moment().utc().isAfter(moment(subscription.expired).utc());
    if (subscription.status === 'EXPIRED' && !trullyExpired) {
      return `EXPIRES AT ${moment(subscription.expired).format('YYYY/MM/DD')}`;
    }

    return subscription.status;
  };

  renderAnchorSubscriptions = (anchorSubscriptions) =>
    anchorSubscriptions.map((anchorSubscription, index) => (<React.Fragment key={index}>
      {this.renderAnchorSubscription(anchorSubscription)}
    </React.Fragment>));

  shouldShowPaysafeForm = (subscription) => {
    if (subscription) {
      return (
        subscription.processorId == 27 ||
          subscription.processorId == 28
      );
    }

    return false;

  };

  handleFormFieldChange = (e) => this.setState({ [e.target.name]: e.target.value });
  handleCountryChange = (e) => {
    this.setState({ country: e.target.value });
  };

  clearErrors = () => {
    this.setState({ errors: [] });
  };

  setPurchaseButtonDisabled = (value) => {
    this.setState({ disablePurchaseButton: value });
  };

  renderSubscriptions = (subscriptions) => subscriptions.map((subscription, index) => {
    const expiresIn =
          subscription.expired &&
          moment(subscription.expired).diff(moment.now(), 'days');

    if (subscription.status === 'ACTIVE' || expiresIn >= 0) {
      return (<React.Fragment key={index}>
        {this.renderSubscription(subscription)}
      </React.Fragment>);
    }
  });

  renderAnchorSubscription = (anchorSubscription) => {
    const {
      anchorName,
      anchorNickname,
      status,
      type,
      created,
      expired,
      isBanned,
    } = anchorSubscription;

    const title = `Naked News - ${anchorName || anchorNickname}`;
    let subscriptionType = type;
    if (anchorSubscription.type === 'CAM4_GOLD') {
      subscriptionType = 'CAM4 Gold Subscription';
    }
    const createdAt = moment(created).utc().format('MMM Do, YYYY');
    const expiredAt = expired && moment(expired).utc().format('MMM Do, YYYY');
    const recurringMessage = this.getRecurringMessage(anchorSubscription);
    const expiredMessage = expired ? `Subscription expires on ${expiredAt}` : null;

    return (
      <li>
        <div className="row subscription-row-wide">
          <div className="subscription-body col-sm-12 col-xs-12 col-xxs-12">
            <h3>{title}</h3>
            <p>Subscription Status: <b>{isBanned ? 'BANNED' : status}</b></p>
            <p>Subscription type: {capitalize(subscriptionType)}</p>
            <p>Subscription created on {createdAt}. {recurringMessage || ''}</p>
            {expiredMessage ? <p>{expiredMessage}.</p> : ''}
          </div>
        </div>
      </li>
    );
  };

  renderSubscription = (subscription) => {
    const createdAt = moment(subscription.created).utc().format('MMM Do, YYYY');
    const canceledAt = moment(subscription.cancelled).utc().format('MMM Do, YYYY');
    const expiredAt = moment(subscription.expired).utc().format('MMM Do, YYYY');
    const canceledMessage = subscription.cancelled ? `Subscription cancelled on ${canceledAt}` : null;
    const expiredMessage = subscription.expired ? `Subscription expires on ${expiredAt}` : null;
    const recurringMessage = this.getRecurringMessage(subscription);
    const title = this.getTitle(subscription.target);
    let subscriptionType = subscription.type;
    if (subscription.type === 'CAM4_GOLD') {
      subscriptionType = 'CAM4 Gold Subscription';
    }

    return (
      <li>
        <div className="row subscription-row-wide">
          <div className="subscription-body col-sm-12 col-xs-12 col-xxs-12">
            <h3>{title}</h3>
            <p>Subscription Status: <b>{this.displaySubscriptionStatus(subscription)}</b></p>
            <p>Subscription type: {capitalize(subscriptionType)}</p>
            <p>Subscription created on {createdAt}. {recurringMessage ? recurringMessage : ''}</p>
            {expiredMessage ? <p>{expiredMessage}.</p> : ''}
            {canceledMessage ? <p>{canceledMessage}.</p> : ''}
          </div>
        </div>
      </li>
    );
  };

  renderPaysafeForm = (subscription) => {
    const { holderName, country, zip, email, errors, processingPayment, disablePurchaseButton } = this.state;
    const { programs } = this.state;
    const { location } = this.props;
    const subscriptionPage = location.pathname === '/account/subscriptions';

    return (
      (this.shouldShowPaysafeForm(subscription)) &&
        <Modal
          closeOnOuterClick={false}
          containerStyle={{
            width: '100%',
            padding: '0',
            marginTop: '100px',
            background: 'transparent',
          }}
          show={this.state.showPaysafeModal}
        >
          <PaysafeForm
            activeProgram={programs[0]}
            addError={this.addError}
            clearErrors={this.clearErrors}
            close={this.closePaysafeModal}
            country={country}
            disablePurchaseButton={disablePurchaseButton}
            email={email}
            errors={errors}
            handleCountryChange={this.handleCountryChange}
            handleFieldChange={this.handleFormFieldChange}
            holderName={holderName}
            processing={processingPayment}
            setPurchaseButtonDisabled={this.setPurchaseButtonDisabled}
            singleUseApiKey={this.state.singleUseApiKey}
            subscriptionPage={subscriptionPage}
            userPremiumExpired={true}
            zip={zip}
            onDismount={this.resetPaysafeForm}
            onSubmit={this.handlePaysafeSubmit}
            onXSellsChange={this.handleXSellsCheckBox}
          />
        </Modal>

    );
  };

  render() {
    const { user: { account: { subscription, subscriptions, anchorSubscriptions } } } = this.props.user;
    const { showAlert, alertMessage, alertType } = this.state;

    return (
      <div className="content">
        {showAlert &&
        <Alert type={alertType} onClose={this.hideAlert}>{alertMessage}</Alert>
        }
        <div className="container">
          <AccountTabs active="/account/subscriptions" />
          {
            this.shouldShowPaysafeForm(subscription) && this.state.singleUseApiKey &&
            <button
              className="btn btn-danger"
              style={{ marginTop: '20px' }}
              onClick={this.openPaysafeModal}
            >
              Update Credit Card Details
            </button>
          }
          <div className="section clearfix">
            <h1>Active subscriptions
              <span
                className="contact-support"
                style={{ fontFamily: 'Montserrat', fontSize: '20px', marginTop: '10px' }}
              >
                Contact Customer support at
                <a href="mailto:support@nakednews.com">support@nakednews.com</a>
              </span>
            </h1>

          </div>
          <div className="well">
            <ul
              className="subscription_list"
              id="active_subscriptions"
            >
              {
                subscription ? this.renderSubscriptions(subscriptions) : <div>
                  <h4 style={{ marginBottom: '20px' }}>You don&apos;t have active subscriptions.</h4>
                  <a className="btn btn-join btn-lg caps" href="/account/purchase">renew membership &gt;&gt;</a>
                </div>
              }
              {
                anchorSubscriptions && anchorSubscriptions.length > 0 ? this.renderAnchorSubscriptions(anchorSubscriptions) : <li>
                  <div className="row subscription-row-wide">
                    <div className="subscription-body col-sm-12 col-xs-12 col-xxs-12">
                      <h3>Naked News - Anchor subscriptions</h3>
                      <p>You don&apos;t have active anchor subscriptions.</p>
                    </div>
                  </div>
                </li>
              }
            </ul>
          </div>
          {this.renderPaysafeForm(subscription)}
        </div>
      </div>
    );
  }
}

export default SubscriptionsPage;
